import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

/**
 * InputStore contains input that is used to create a recommendation/measurement.
 * It is persisted in localstorage since it can be used again with a new product id.
 */
interface InputStore {
  scanID?: string;
  previousPurchaseID?: string;
  email?: string;
  subject?: string;
  setScanID: (id: string | undefined) => void;
  setPreviousPurchaseID: (si: string | undefined) => void;
  setEmail: (m: string) => void;
  setSubject: (m: string) => void;
  clearScanID: () => void;
  clearPreviousPurchaseID: () => void;
  clear: () => void;
}

export const useInputStore = create<InputStore>()(
  devtools(
    persist(
      (set) => ({
        scanID: undefined,
        email: undefined,
        previousPurchaseID: undefined,
        subject: undefined,
        setPreviousPurchaseID: (by) => {
          set(() => ({ previousPurchaseID: by }));
        },
        setScanID: (by) => {
          set(() => ({ scanID: by }));
        },
        setEmail: (by) => {
          set(() => ({ email: by }));
        },
        setSubject: (by) => {
          set(() => ({ subject: by }));
        },
        clearScanID: () => {
          set(() => ({ scanID: undefined }));
        },
        clearPreviousPurchaseID: () => {
          set(() => ({ previousPurchaseID: undefined }));
        },
        clear: () => {
          set(() => ({
            scanID: undefined,
            email: undefined,
            previousPurchaseID: undefined,
          }));
        },
      }),
      {
        name: 'visa-input',
      },
    ),
  ),
);
